import { callYaMetrikaMethod } from 'core/utils/counters-helper';
import { dateFormat } from 'core/utils/dates';

import { LocalStorage } from 'core/decorators';

export const SHOW_OFFLINE_PAGE = 'show_offline_page';
export const CLICK_TOPIC = 'click_topic_offline_page';
const OFFLINE_EVENTS = 'offline_events';

export function storeOfflineEvent(target, params) {
  if (!target) return;

  const events = JSON.parse(LocalStorage.getItem(OFFLINE_EVENTS)) || [];
  events.push({
    target,
    params: {
      date: dateFormat(Date.now(), "yyyy-MM-dd'T'HH:mm:ss"),
      ...params,
    },
  });
  LocalStorage.setItem(OFFLINE_EVENTS, JSON.stringify(events));
}


export function sendOfflineEvents(ymIds) {
  const events = JSON.parse(LocalStorage.getItem(OFFLINE_EVENTS)) || [];

  if (!events.length) return;

  events.forEach(event => {
    callYaMetrikaMethod(ymIds, 'reachGoal', event.target, event.params);
  });

  LocalStorage.removeItem(OFFLINE_EVENTS);
}
